<div class="common-wrapper">
    <div class="main-hd-txt">
        
        <span>
            <h4>AGENDA PURPOSE<span class="head-btn-style">
                <button *ngIf="!listView" (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab">
                    <i class="bi bi-arrow-left-circle"></i> Back</button></span><span class="head-btn-style">
                    <button *ngIf="!listView" (click)="save($event)" class="save-btn-head" [disabled]="saveDisabled" title="Save">
                    <i class="bi bi-file-earmark-plus"></i> Save</button></span></h4>
        </span>
    </div>
    <div *ngIf="listView" class="top-btns">
        <grid [entities]="Purpose" [actionExclude]="['feedback','column']" [checkboxCol]="true"
            [entityColumns]="PurposeColumns" [selectionField]="'Purpose_Id'" [addEntityIcon]="'bi bi-plus-square'"
            [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'" (addEntity)="addPurpose($event)"
            (downloadEntities)="onExcelExport()" (editEntity)="editPurpose($event)"
            (refreshEntities)="refreshDepartments($event)" (deleteEntity)="deletePurpose($event)"
            (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
            [pageSize]="defaultPageSize" [skip]="pageSkip" (onFilterChange)="onFilterChange($event)">
        </grid>

    </div>

    <div *ngIf="!listView">
        <div class="row sub-head">
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearPurpose()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div>
        </div>

        <div class="col-md-12 content-area">
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Purpose Name'" [formData]="entity" [maxlength]="50" [mandatory]="true"
                        [fieldName]="'PurposeName'" [(ngModel)]="entity.PurposeName"
                        ngDefaultControl>
                    </textbox>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Code'" [formData]="entity" [maxlength]="10" [mandatory]="true"
                        [fieldName]="'PurposeCode'" [(ngModel)]="entity.PurposeCode" ngDefaultControl>
                    </textbox>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Purpose Order'" [formData]="entity" [maxlength]="5" [mandatory]="true"
                        [fieldName]="'PurposeOrder'" (paste)="onPaste($event)"  (keypress)="numberOnly($event)" [(ngModel)]="entity.PurposeOrder" ngDefaultControl>
                    </textbox>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Purpose Description '" [formData]="entity" [maxlength]="500" [mandatory]="true"
                        [fieldName]="'PurposeDescription'"  [(ngModel)]="entity.PurposeDescription" ngDefaultControl>
                    </textbox>
                </div>
            </div> -->
            <div class="row">
                <div class="col-md-4 mb-2">
                    <checkbox [caption]="' Active'" [(ngModel)]="entity.IsActive"></checkbox>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-1">
                    <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'" [type]="'button'"
                        title="Back Tab"></btn>
                </div>
                <div class="col-md-4 mb-2">
                    <btn [label]="'Save'" (click)="save($event)" [class]="'btn-1 btn-11'" [disabled]="saveDisabled"
                        [type]="'button'"></btn>
                </div>
            </div> -->
        </div>
        
    </div>
</div>
<ng-template #view let-dataItem let-rowIndex="rowIndex">
    <i class="bi bi-eye-fill" (click)="open(dataItem)"></i>
  </ng-template>
  <kendo-dialog title="Agenda Purpose Details" *ngIf="opened" (close)="close()" [height]="500" [width]="1000">
    <div class="col-md-12 content-area">
        <div class="row">
          <div class="col-md-4 br-table-data">
            <label for="PurposeName" class="label label-1"> Purpose Name : </label> {{details.PurposeName }}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="PurposeCode" class="label label-1">Code : </label> {{details.PurposeCode}}
          </div>
        </div>
        </div>
    </kendo-dialog>
<kendo-excelexport [data]="Purpose.data" [collapsible]="true" fileName="AgendaPurposeCode.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="Sl.No." [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="PurposeName" title="Purpose Name" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="PurposeCode" title="Code" [width]="200">
    </kendo-excelexport-column>
    <!-- <kendo-excelexport-column field="PurposeOrder" title="Order" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="PurposeDescription" title="Description" [width]="200">
    </kendo-excelexport-column> -->
    <kendo-excelexport-column field="Active" title="Active" [width]="200">
    </kendo-excelexport-column>
</kendo-excelexport>